import script from "./AdminDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminDashboard.vue?vue&type=script&setup=true&lang=js"

import "./AdminDashboard.vue?vue&type=style&index=0&id=3070891a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3070891a"]])

export default __exports__